import Sidebar from "./ui/Sidebar";
import Navbar from "./ui/Navbar";
import { Route, Switch, useHistory } from "react-router-dom";   
import { useSelector } from "react-redux";
import Publishers from "./publishers/Publishers";
import ConfirmPopup from './common/ConfirmPopup';
import PublisherProfile from "./publishers/PublisherProfile";

const PublisherPortal = () => {
    let history = useHistory();

    useSelector(state => {
        let accessToken = state.auth.accessToken;
        if (accessToken === null) {
            history.push('/login');
            return;
        }
    });

    return (
        <div className="wrapper">
            <Sidebar />

            <div className="main">
                <Navbar />

                <div className="content">
                    <Switch>
                        <Route path="/publishers" component={Publishers} />
                        <Route path="/profile" component={PublisherProfile}/>
                    </Switch>
                </div>

                <div className="footer">
                </div>

                <ConfirmPopup />
            </div>


        </div>
    );
};

export default PublisherPortal;

